import React from 'react';
import { useSearchParams } from 'react-router-dom';
import IncidentsTab from '../components/monitoring/IncidentsTab';
import FailedEmailsTab from '../components/monitoring/FailedEmailsTab';

/**
 * Écran « Monitoring » (lot I5) — LECTURE SEULE, dans le panneau d'administration.
 *
 * Deux sous-onglets, pilotés par l'URL (`/monitoring?vue=incidents` | `?vue=emails`) : l'état est
 * partageable et rechargeable, comme les onglets de la fiche client.
 *   ① « Incidents serveur » : la collection `serverMonitoring` (canal d'escalade écrit par le
 *      serveur), jusqu'ici lisible seulement par une commande serveur ;
 *   ② « Emails en échec » : les envois du journal « mail » qui n'ont PAS abouti, toutes fiches
 *      confondues (pendant « parc » de l'onglet Emails de la fiche client, lot I2a).
 *
 * Rien ici ne peut MODIFIER une donnée (DI5-9) : ni acquittement d'incident, ni renvoi, ni
 * suppression. Aucune cloche n'est ajoutée (DI5-10).
 */

const VUES = [
  { id: 'incidents', label: 'Incidents serveur' },
  { id: 'emails', label: 'Emails en échec' }
];

/**
 * Sous-onglet par défaut. Le cadrage I5 (DI5-7) fixe la vue par défaut sur les ÉCHECS : ouvrir
 * « Monitoring » montre d'abord les envois qui n'ont pas abouti — le besoin nº 1 du demandeur.
 */
const VUE_PAR_DEFAUT = 'emails';

const MonitoringPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const vueDemandee = searchParams.get('vue');
  const vue = VUES.some((item) => item.id === vueDemandee) ? vueDemandee : VUE_PAR_DEFAUT;

  const choisirVue = (id) => {
    const suivants = new URLSearchParams(searchParams);
    suivants.set('vue', id);
    setSearchParams(suivants);
  };

  return (
    <div className="space-y-4">
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div>
          <h1 className="text-2xl font-bold text-base-content">Monitoring</h1>
          <p className="text-sm text-base-content/70 mt-1">
            Surveillance du parc en LECTURE SEULE : incidents serveur et emails en échec.
          </p>
        </div>
        <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-info/20 text-info border border-info/30">
          lecture seule
        </span>
      </div>

      <div className="bg-base-100 rounded-lg shadow-sm border border-base-200">
        <div className="border-b border-base-200 overflow-x-auto">
          <nav className="flex px-2">
            {VUES.map((item) => (
              <button
                key={item.id}
                type="button"
                onClick={() => choisirVue(item.id)}
                className={`px-4 py-3 whitespace-nowrap border-b-2 transition-colors ${
                  vue === item.id
                    ? 'border-primary text-primary font-medium'
                    : 'border-transparent text-base-content/70 hover:text-base-content'
                }`}
              >
                {item.label}
              </button>
            ))}
          </nav>
        </div>

        <div className="p-5">
          {vue === 'incidents' && <IncidentsTab />}
          {vue === 'emails' && <FailedEmailsTab />}
        </div>
      </div>
    </div>
  );
};

export default MonitoringPage;
